// English translation

const en = {
  "menu.staff_assistance": "Assistance Control",
  "menu.assistance": "Assistance Control",
  "menu.audit": "Assistance Audit",
  "staff.assistance.main_desc":
    "Control and audit the attendance of your organization's staff.",
  "staff.assistance.control_title": "Assistance Control",
  "staff.assistance.control_desc":
    "Register and manage staff attendance records.",
  "staff.assistance.audit_title": "Assistance Audit",
  "staff.assistance.audit_desc":
    "Audit and verify attendance records.",
  "staff.assistance.audit.search": "Search",
  "staff.assistance.audit.empty":
    "Select the dates and press Search to audit the assistance.",
  "staff.assistance.audit.no_data":
    "No records found for the selected filters.",
  "staff.assistance.audit.require_dates":
    "The start date is required.",
  "staff.access.type": "Type",
  "staff.assistance.audit.start_date": "Start Date",
  "staff.assistance.audit.end_date": "End Date",
  "staff.access.audit.name": "Employee",
  "staff.access.audit.shift_code": "Shift",
  "staff.access.audit.enter_shift": "Shift In",
  "staff.access.audit.exit_shift": "Shift Out",
  "staff.access.audit.enter_effective": "Effective In",
  "staff.access.audit.exit_effective": "Effective Out",
  "staff.access.audit.enter_biometric": "Biometric In",
  "staff.access.audit.exit_biometric": "Biometric Out",
  "staff.access.audit.ttt": "TTT",
  "staff.access.audit.hedo": "HEDO",
  "staff.access.audit.heno": "HENO",
  "staff.access.audit.hedf": "HEDF",
  "staff.access.audit.henf": "HENF",
  "staff.access.audit.reco": "RECO",
  "staff.access.audit.recf": "RECF",
  "staff.access.audit.view_events": "Novelties",
  "staff.access.audit.events_empty":
    "The employee has no novelties in the selected range.",
  "staff.access.audit.events_category": "Category",
  "staff.access.audit.events_description": "Description",
  "staff.access.audit.events_date": "Date",
  "staff.access.audit.events_range": "Range",
  "staff.access": "Assistance Control",
  "staff.access.employee": "Employee",
  "staff.access.employee.filter": "Filter employee",
  "staff.access.enter_timestamp": "Enter Timestamp",
  "staff.access.exit_timestamp": "Exit Timestamp",
  "staff.access.start_rest": "Start Rest",
  "staff.access.end_rest": "End Rest",
  "staff.access.enter_biometric": "Enter Biometric",
  "staff.access.exit_biometric": "Exit Biometric",
  "staff.access.state": "State",
  "staff.access.state.filter": "Filter state",
  "staff.access.activity": "Activity",
  "staff.access.extras_approval": "Extras Approval",
  "staff.access.request_reason": "Request Reason",
  "staff.access.is_billable": "Is Billable",
  "staff.access.create_shift_schedule": "Create Shift Schedule",
  "staff.access.create_access_filter": "Filter",
  "staff.access.start_date": "Start Date",
  "staff.access.end_date": "End Date",
  "staff.access.create_staff_assistance": "Create Staff Assistance",
  "staff.access.close_staff_assistance": "Finish",
  "staff.access.kind_start": "Start Time",
  "staff.access.kind_start_rest": "Start Rest",
  "staff.access.kind_end_rest": "End Rest",
  "staff.access.kind_end": "End Time",
  "staff.access.shift_info": "Shift Information",
  "staff.access.shift": "Shift",
  "staff.access.section": "Sección",
  "staff.access.section.filter": "Filter section",
  "staff.access.extras": "Extras",
  "staff.access.close": "Close",
  "staff.access.shift_unit_cost": "Unit Cost",
  "staff.access.is_billable.billable": "Billable",
  "staff.access.is_billable.no_billable": "No Billable",
  "staff.access.state.open": "Open",
  "staff.access.state.close": "Closed",
  "staff.access.state.done": "Finished",
  "staff.access.state.approved": "Approved",
  "staff.access.state.not_approved": "Not Approved",
  "staff.access.enter_permission": "Enter Permission",
  "staff.access.exit_permission": "Exit Permission",
  "staff.access.daily_report": "Daily Report",
  "staff.access.daily_report.description": "Daily Report",
  "staff.access.wizard_daily": "Daily Report",
  "staff_access.daily_report.start_date": "Start Date",
  "staff_access.daily_report.end_date": "End Date",
  "staff_access.daily_report.section": "Section",
  "staff_access.daily_report.kind": "Kind",
  "staff_access.daily_report.only_overtime": "Only Overtime",
  "staff.access.ttt": "TTT",
  "staff.access.hedf": "HEDF",
  "staff.access.hedo": "HEDO",
  "staff.access.henf": "HENF",
  "staff.access.heno": "HENO",
  "staff.access.reco": "RECO",
  "staff.access.recf": "RECF",
  "staff.access.dom": "DOM",
  "staff.access.notes": "Notes",
  "staff.access.all": "All",
  "staff.access.enter_date": "Enter Date",
  "staff.access.fmt_time": "Enter Time",
  "staff.access.enter_date_bio": "Enter Bio",
  "staff.access.fmt_time_bio": "Time Bio",
  "staff.access.approve": "Approve",
  "staff.access.not_approve": "Not Approve",
  "staff.access.payroll": "Payroll",
  "staff.access.shift_amount": "Shift Amount",
  "staff.access.shift_amount_extra": "Shift Amount Extra",
  "staff.access.shift_amount_transport": "Shift Amount Transport",
  "staff.access.het": "HET",
  "staff.access.open": "Open",
  "staff.access.done": "Done",
  "staff_access.daily_report.sections": "Sections",
  "staff_access_extratime.daily_report": "Daily Report",
  "staff.access.approve_group_filter": "Filter",
  "staff.access.approve_group_access": "Approve Group",
  "staff.access.compensatory_date": "Compensatory Date",
  "staff.access.compensated": "Compensated",
  "staff.access.permissions": "Permissions",
  "staff.access.view_events": "View Novelties",
  "staff.access.shift_hours":"Shift hour",
  "staff.access.shift_schedule_het": "Scheduled HET"

};

export default en;
